import { SEGMENTS } from '../editor-ui/constants';

export function generateSegment(conditions) {
  return JSON.stringify({
    version: 1,
    operator: 'and',
    conditions: conditions.map(generateSegmentCondition),
  });
}

function generateSegmentCondition({ type, values }) {
  switch (type) {
    case SEGMENTS.NEW_VISITORS:
      return { criteria: 'new_or_returning', comparison: 'any', value: ['new'] };
    case SEGMENTS.RETURNING_VISITORS:
      return { criteria: 'new_or_returning', comparison: 'any', value: ['returning'] };
    case SEGMENTS.DIRECT_VISITORS:
      return { criteria: 'referrer', comparison: 'any', value: [{ url: '' }] };
    case SEGMENTS.REFERRER:
      return { criteria: 'referrer', comparison: 'any', value: values.map((v) => ({ url: v })) };
    case SEGMENTS.URL_PARAMETER:
      return { criteria: 'query_param', comparison: 'any', name: values.k, value: values.v };
    case SEGMENTS.AD_TRAFFIC:
      return { criteria: values.k, comparison: 'any', value: values.v };
  }
}

export function parseSegment(stringSegment) {
  if (stringSegment == null) return { type: SEGMENTS.EVERYONE };
  const segment = JSON.parse(stringSegment);
  const condition = segment.conditions[0];

  switch (condition.criteria) {
    case 'new_or_returning':
      {
        switch (condition.value[0]) {
          case 'new':
            return { type: SEGMENTS.NEW_VISITORS };
          case 'returning':
            return { type: SEGMENTS.RETURNING_VISITORS };
        }
      }
      break;
    case 'referrer': {
      if (condition.value[0].url === '') {
        return { type: SEGMENTS.DIRECT_VISITORS };
      }
      return { type: SEGMENTS.REFERRER, values: condition.value.map((x) => x.url) };
    }
    case 'query_param': {
      return { type: SEGMENTS.URL_PARAMETER, values: segment.conditions.map((c) => ({ k: c.name, v: c.value })) };
    }
    case condition.criteria.match(/^utm_/)?.input: {
      return { type: SEGMENTS.AD_TRAFFIC, values: segment.conditions.map((c) => ({ k: c.criteria, v: c.value })) };
    }
  }
}

export function getSegmentAsText(segment) {
  const { type, values } = parseSegment(segment);

  switch (type) {
    case SEGMENTS.EVERYONE:
      return { name: 'Everyone' };
    case SEGMENTS.NEW_VISITORS:
      return { name: 'New visitors' };
    case SEGMENTS.RETURNING_VISITORS:
      return { name: 'Returning visitors' };
    case SEGMENTS.DIRECT_VISITORS:
      return { name: 'Direct visitors' };
    case SEGMENTS.REFERRER:
      return { name: 'Referrer', details: values.map((v) => `• ${v}`).join('\n') };
    case SEGMENTS.URL_PARAMETER:
      return {
        name: 'URL parameter',
        details: values.map(({ k, v }) => `• ${k} IS ${v.map((value) => `"${value}"`).join(' OR ')}`).join('\nAND\n'),
      };
    case SEGMENTS.AD_TRAFFIC:
      return {
        name: 'Ad traffic',
        details: values.map(({ k, v }) => `• ${k} IS ${v.map((value) => `"${value}"`).join(' OR ')}`).join('\nAND\n'),
      };
  }
}
